










































































































import Vue from 'vue';
import { isObject, startCase, inRange, get, has } from 'lodash';
import { BButton } from 'bootstrap-vue';

import LoadingSpinner from '@reciprocity/loading-spinner';
import InlineEditButton from './components/edit/InlineEditButton.vue';

import { Column, ColumnSortDirection, DataRow, SortBy } from './types';
import * as CellPresenters from './cell_presenters';

import ColumnResizer from './components/columns/ColumnResizer.vue';

export default Vue.extend({
  name: 'ZenTable',
  components: {
    ...CellPresenters,
    BButton,
    LoadingSpinner,
    InlineEditButton,
    ColumnResizer,
  },
  props: {
    columns: {
      type: Array as () => Column[],
      required: true,
    },
    sort: {
      type: Object as () => SortBy | null,
      default: null,
    },
    data: {
      type: Array as () => DataRow[],
      required: true,
    },
    emptyText: {
      type: String,
      default: 'No data to display',
    },
    busy: {
      type: Boolean,
      default: false,
    },
    tableId: {
      type: String,
      default: undefined,
    },
    enableEditing: {
      type: Boolean,
      default: false,
    },
    selectedObjects: {
      type: Array,
      default: () => [],
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    resizableCols: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedColumns() {
      return this.columns.map((col: Column | string) => {
        const colObj = isObject(col) ? (col as Column) : { key: col };
        if (has(colObj, 'label') && colObj.label == null) {
          return colObj;
        }
        colObj.label = colObj.label || startCase(colObj.key);
        return colObj;
      });
    },
    // This is cleaner solution than custom v-model code on checkboxes
    selectedRows: {
      get() {
        return this.selectedObjects.map(el => el.id);
      },
      set(rows) {
        this.$emit('selectedRowsChange', rows);
      },
    },
    selectAllState() {
      return {
        indeterminate: inRange(this.selectedObjects.length, 1, this.data.length),
        checked: this.selectedObjects.length === this.data.length,
      };
    },
    columnsCount() {
      // TODO move calculation of fields to meta config data
      return this.computedColumns.length + (this.enableEditing && 1);
    },
  },
  // Update for resizer is called from here to avoid infinite loop
  updated() {
    if (this.$refs.resizer) {
      this.$refs.resizer.updateLayout();
    }
  },
  methods: {
    clickHandler(col: Column): void {
      return this.isSortable(col) ? this.sortChange(col) : null;
    },
    sortChange(col: Column): void {
      this.$emit('sortChange', col.key);
    },
    isSortable(col: Column): boolean {
      return col.sortable && this.sort != null;
    },
    hasActiveSort(col: Column): boolean {
      return this.sort.by == col.key;
    },
    sortByDirectionClass(col: Column): string {
      // Default state
      if (!this.hasActiveSort(col)) return 'fa-caret-up';

      return this.sort.direction == ColumnSortDirection.Asc ? 'fa-caret-up' : 'fa-caret-down';
    },
    onSelectAll() {
      this.selectedRows = this.selectAllState.checked ? [] : this.data.map(r => r.id);
    },
    onEditButtonClick(row: DataRow, col: Column) {
      const event: string =
        col.presenter === 'MappedObjects' || col.presenter === 'RelatedObjects' ? 'inlineMapClick' : 'inlineEditClick';
      const emitCol: Column | undefined = col.presenter === 'RelatedObjects' ? undefined : col;

      // TODO: Figure out mapping permissions
      this.$emit(event, row.id, emitCol, row[col.key]);
    },
    renderRowDetails(row: DataRow): void {
      return get(row, 'meta.rowDetails.active', false);
    },
    rowClick(row, index, event) {
      this.$emit('rowClick', { row, index, event });
    },
    onColumnSizeChange(col, size) {
      this.$emit('columnSizeChange', col, size);
    },
    inlineColumnStyle(width) {
      if (width) {
        return {
          width: `${width}px !important`,
          minWidth: `${width}px !important`,
          maxWidth: `${width}px !important`,
        };
      } else {
        return {};
      }
    },
  },
});
